// src/utils/themeConfig.js

export const getThemeColors = (theme) => {
  const themes = {
    white: {
      // Main colors
      primary: '#0066FF',
      primaryHover: '#0052CC',
      primaryLight: '#E6F0FF',
      
      // Backgrounds
      background: '#F9FAFB',
      cardBg: '#FFFFFF',
      inputBg: '#FFFFFF',
      hoverBg: '#F3F4F6',
      
      // Text colors
      text: '#111827',
      textSecondary: '#6B7280',
      textMuted: '#9CA3AF',
      
      // Borders
      border: '#E5E7EB',
      borderHover: '#D1D5DB',
      borderFocus: '#0066FF',
      
      // Status colors
      success: '#10B981',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#0066FF',
      
      // XP and gamification
      xpBg: '#FEF3C7',
      xpText: '#92400E',
      xpAccent: '#F59E0B',
      
      // Shadows
      shadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      shadowLg: '0 10px 15px rgba(0, 0, 0, 0.1)',
    },
    
    blue: {
      // Main colors
      primary: '#3B82F6',
      primaryHover: '#2563EB',
      primaryLight: '#DBEAFE',
      
      // Backgrounds
      background: '#EFF6FF',
      cardBg: '#DBEAFE',
      inputBg: '#FFFFFF',
      hoverBg: '#BFDBFE',
      
      // Text colors
      text: '#1E3A8A',
      textSecondary: '#1E40AF',
      textMuted: '#3B82F6',
      
      // Borders
      border: '#BFDBFE',
      borderHover: '#93C5FD',
      borderFocus: '#3B82F6',
      
      // Status colors
      success: '#10B981',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#3B82F6',
      
      // XP and gamification
      xpBg: '#FEF3C7',
      xpText: '#92400E',
      xpAccent: '#F59E0B',
      
      // Shadows
      shadow: '0 1px 3px rgba(59, 130, 246, 0.1)',
      shadowLg: '0 10px 15px rgba(59, 130, 246, 0.15)',
    },
    
    orange: {
      // Main colors
      primary: '#EA580C',
      primaryHover: '#C2410C',
      primaryLight: '#FFEDD5',
      
      // Backgrounds
      background: '#FFF7ED',
      cardBg: '#FFEDD5',
      inputBg: '#FFFFFF',
      hoverBg: '#FED7AA',
      
      // Text colors
      text: '#7C2D12',
      textSecondary: '#9A3412',
      textMuted: '#C2410C',
      
      // Borders
      border: '#FED7AA',
      borderHover: '#FDBA74',
      borderFocus: '#EA580C',
      
      // Status colors
      success: '#10B981',
      error: '#DC2626',
      warning: '#F59E0B',
      info: '#EA580C',
      
      // XP and gamification
      xpBg: '#FEF3C7',
      xpText: '#92400E',
      xpAccent: '#F59E0B',
      
      // Shadows
      shadow: '0 1px 3px rgba(234, 88, 12, 0.1)',
      shadowLg: '0 10px 15px rgba(234, 88, 12, 0.15)',
    }
  };

  // Return white theme as default if theme is undefined or not found
  return themes[theme] || themes.white;
};

// Get CSS variables for theme
export const getThemeCSSVariables = (theme) => {
  const colors = getThemeColors(theme);
  
  return {
    '--theme-primary': colors.primary,
    '--theme-primary-hover': colors.primaryHover,
    '--theme-primary-light': colors.primaryLight,
    '--theme-background': colors.background,
    '--theme-card-bg': colors.cardBg,
    '--theme-input-bg': colors.inputBg,
    '--theme-hover-bg': colors.hoverBg,
    '--theme-text': colors.text,
    '--theme-text-secondary': colors.textSecondary,
    '--theme-text-muted': colors.textMuted,
    '--theme-border': colors.border,
    '--theme-border-hover': colors.borderHover,
    '--theme-border-focus': colors.borderFocus,
    '--theme-success': colors.success,
    '--theme-error': colors.error,
    '--theme-warning': colors.warning,
    '--theme-info': colors.info,
    '--theme-xp-bg': colors.xpBg,
    '--theme-xp-text': colors.xpText,
    '--theme-xp-accent': colors.xpAccent,
  };
};

// Helper to apply theme to element
export const applyThemeToElement = (element, theme) => {
  if (!element) return;
  
  const cssVars = getThemeCSSVariables(theme);
  Object.entries(cssVars).forEach(([key, value]) => {
    element.style.setProperty(key, value);
  });
};